// src/firebase/firebase.js
import { initializeApp, getApps, getApp } from "firebase/app";
import { 
  getAuth,
  onAuthStateChanged, 
  signInAnonymously,
  setPersistence, 
  browserLocalPersistence 
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBTZgqekOt1qtNFwCoFQgBU0JzZyFmDgQk",
  authDomain: "thothbot-c8edf.firebaseapp.com",
  projectId: "thothbot-c8edf",
  storageBucket: "thothbot-c8edf.firebasestorage.app",
  messagingSenderId: "936341252270",
  appId: "1:936341252270:web:c7e9711fa9dd85f3f9a53f",
  measurementId: "G-ZGRKS6R66Q",
};

const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();

export const auth = getAuth(app);
setPersistence(auth, browserLocalPersistence);
export const db = getFirestore(app);

let userInitPromise = null;

export function getFirebaseUserId() {
  if (auth.currentUser) {
    return Promise.resolve(auth.currentUser.uid);
  }

  if (!userInitPromise) {
    userInitPromise = new Promise((resolve, reject) => {
      const unsubscribe = onAuthStateChanged(
        auth,
        async (user) => {
          unsubscribe();

          try {
            if (user) {
              resolve(user.uid);
            } else {
              const cred = await signInAnonymously(auth);
              resolve(cred.user.uid);
            }
          } catch (err) {
            reject(err);
          }
        },
        reject
      );
    });
  }

  return userInitPromise;
}